import React from 'react';
import { Container, Typography } from '@mui/material';

export default function AudioSummaries()
{
    return (
        <div
            style={{
                position: "fixed",
                left: 0,
                right: 0,
                top: "70px",
                bottom: "0",
                overflow: "hidden",
            }}
        >
            <Container component="main" maxWidth="lg">
                <Typography sx={{ mt: 2 }} align="center">
                    Busy life? On calls, family, commuting?
                </Typography>

                <Typography align="center">
                    Make smarter use of your time and learn from incredible sources delivered in an easily digestible way.
                </Typography>

                <Typography align="center">
                    We've used Google Notebook LM to generate conversational style audio summaries on hot, exam relevant topics in haematology.
                </Typography>

                <Typography align="center">
                    Feel like we're missing something? Drop us a message, or make your own - Google Notebook LM is free and hugely powerful so why not give it a go!
                </Typography>

                <Typography sx={{ mb: 2 }} align="center">
                    This is a podcast also available on all major podcast platforms.
                </Typography>

            </Container>

            <iframe
                title="audio summaries"
                src="https://embed.acast.com/68beeb540e15f0d455abc0b7?feed=true"
                style={{
                    width: "100%",
                    height: "100%",
                    border: 0,
                    display: "block",
                }}
            />
        </div>
    );
}